import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelAmazonIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.23634 6.53975C9.23634 7.33826 9.25513 8.00196 8.85328 8.71167C8.52792 9.28916 8.01005 9.6437 7.43645 9.6437C6.6496 9.6437 6.19072 9.04482 6.19072 8.15816C6.19072 6.41336 7.75598 6.09577 9.23698 6.09577L9.23634 6.53975ZM11.3013 11.5337C11.1659 11.6562 10.9695 11.664 10.8184 11.5816C10.1366 11.0165 10.016 10.7546 9.64272 10.2167C8.51884 11.3619 7.72293 11.7054 6.26655 11.7054C4.5425 11.7054 3.2002 10.6418 3.2002 8.51334C3.2002 6.85086 4.10176 5.7205 5.38443 5.16634C6.49599 4.67764 8.04829 4.58884 9.23569 4.45662V4.19088C9.23569 3.70283 9.27458 3.12663 8.98745 2.70405C8.73792 2.32877 8.25894 2.17257 7.837 2.17257C7.05599 2.17257 6.36118 2.57312 6.19072 3.4021C6.15572 3.58682 6.02155 3.76959 5.83489 3.77931L3.85093 3.56348C3.68306 3.52719 3.49575 3.39108 3.54501 3.13571C4.0013 0.727215 6.17646 0 8.12477 0C9.12097 0 10.4237 0.265738 11.2086 1.02017C12.2055 1.95091 12.1108 3.19275 12.1108 4.54477V7.73557C12.1108 8.69547 12.5101 9.11611 12.8834 9.63398C13.0156 9.81999 13.0435 10.0423 12.8769 10.1778C12.4576 10.5284 11.7142 11.174 11.3065 11.5382L11.3013 11.5337Z"
          fill="#F7F9FD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6878 13.2667C11.9067 14.2208 9.97073 14.6803 8.20908 14.6803C5.59902 14.6803 3.07127 13.7775 1.02703 12.2783C0.847493 12.1474 0.715272 12.3781 0.864345 12.548C2.76016 14.7037 5.26263 16 8.04316 16C10.0271 16 12.33 15.2131 13.9192 13.7353C14.1824 13.491 13.9568 13.1229 13.6878 13.2667ZM14.1221 14.703C14.0631 14.8502 14.1895 14.9104 14.323 14.7983C15.1909 14.0724 15.4151 12.5518 15.2375 12.3328C15.0612 12.115 13.5446 11.927 12.619 12.5771C12.4764 12.6769 12.5011 12.815 12.6592 12.7955C13.181 12.7333 14.3412 12.5933 14.5473 12.8591C14.754 13.1248 14.3172 14.2163 14.1221 14.703Z"
          fill="#F7F9FD"
        />
      </SvgIcon>
    );
  })
);
